export enum UserRoleEnum {
  ADMIN = 'admin',
  GOLFER = 'golfer',
  COACH = 'coach',
  API_USER = 'api-user',
  LEAD = 'lead',
}
